import styled from '@emotion/styled';
import { Theme } from '@/styles/Theme';

export const LastHistoryWrapper = styled.div<{ size?: 'small' | 'large'; layout?: 'horizontal' | 'vertical' }>`
  display: flex;
  flex-direction: ${({ layout }) => layout === 'vertical' ? 'column' : 'row'};
  align-items: ${({ layout }) => layout === 'vertical' ? 'flex-end' : 'center'};
  gap: ${({ layout }) => layout === 'vertical' ? '0.125rem' : '0.25rem'};

  font-size: ${({ size }) => size === 'small' && '0.875rem'};
`;
export const LastHistoryLabel = styled.span`
  color: ${Theme.colors.B_2};
  font-weight: 700;
`;

export const LastEditor = styled.span<{ size?: 'small' | 'large'; layout?: 'horizontal' | 'vertical' }>`
  font-weight: 700;
  white-space: ${({ layout }) => layout === 'vertical' ? 'normal' : 'nowrap'};
  font-size: ${({ size }) => size === 'small' ? '0.75rem' : '0.875rem'};
  text-align: ${({ layout }) => layout === 'vertical' ? 'right' : 'left'};
  
  ${({ layout }) => layout === 'vertical' && `
    max-width: 150px;
    word-wrap: break-word;
    line-height: 1.2;
  `}
`;

export const TimeElement = styled.time`
  white-space: nowrap;
  font-size: inherit;
`;
